import { clearTimeouts, engine as anime } from "../index";
import { getTemplateDurationOveride } from "../../components/shared/utils/timeline";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format, templateName, data } = props;

  const timeline = anime.timeline();
  const templateDuration = getTemplateDurationOveride({
    apiSetup: props?.apiSetup,
    tournamentId: props?.data?.event?.competitionId,
    fallback:
      _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
    templateName,
    event: data?.event
  });
  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );
  // $(`#${id} .table-head, #${id} .table-row, #${id} .teilnahmen-note`).css("opacity", 0);

  anime({
    targets: [`#${id} .qatar-logo`],
    duration: 800,
    easing: "easeOutQuint",
    scale: [0, 1],
    opacity: [1, 1],
    delay: 200,
  });

  anime({
    targets: [`#${id} .group-label`],
    duration: 800,
    easing: "easeOutQuint",
    scale: [0, 1],
    opacity: [1, 1],
    delay: 400,
  });

  const timeout1 = setTimeout(() => {
    anime({
      targets: [`#${id} .table-head`],
      duration: 1000,
      easing: "easeOutQuint",
      translateX: [-2000, 0],
      opacity: [1, 1],
      delay: anime.stagger(100),
    });

    anime({
      targets: [`#${id} .table-row`],
      duration: 1000,
      easing: "easeOutQuint",
      translateX: [-2000, 0],
      opacity: [1, 1],
      delay: anime.stagger(100),
    });

    anime({
      targets: [`#${id} .teilnahmen-note`],
      duration: 1000,
      easing: "easeOutQuint",
      opacity: [0, 1],
      delay: 500,
    });
  }, 600);

  timeouts.push(timeout1);

  return {
    timeline: [],
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
